import ApiClient from '../backend/ApiClient'
import { snackbar } from '../components/services/SnackbarService'
import { IUser } from '../definitions/Users'
import { clearCurrentUser } from '../store/slices/AppSlice'
import { store } from '../store/Store'

class UsersManagerClass {
    _user: IUser = null

    getAllUsers = async (): Promise<IUser[]> => {
        try {
            const result = await ApiClient.getAllUsers()
            return result
        } catch (error) {
            console.error('Error while fetching all Users', error)
        }
    }

    getCurrentUser = (): IUser => {
        const currentUser = store.getState().app.currentUser
        return currentUser
    }

    logout(navigate?): void {
        store.dispatch(clearCurrentUser())
        snackbar.show({
            severity: 'success',
            text: 'Successfully logged out.'
        })

        // If a navigation function is provided, redirect the user
        if (navigate && typeof navigate === 'function') {
            navigate('/login') // Ensure this route exists
        }
    }
}

const UsersManager = new UsersManagerClass()
export default UsersManager
